"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveInReducerFunction = exports.moveInActions = exports.moveInState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
exports.initialState = {
    formData: {
        billingAddress: null,
        accountHolder: null,
        jointAccountHolder: null,
        inseeCode: null,
        movingInRequestId: null,
        billingInformation: null,
        estimatedConsumption: null,
        meter: null,
        deliveryPoint: null,
        residence: null,
    },
    communeAutoComplete: {
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null,
        communeSuggestions: [],
        selectedValue: null
    },
    communeEligibility: {
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null,
        eligibility: null,
        disabled: null,
        crmEnabled: null
    },
    movingInRequestCreation: {
        data: null,
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null
    },
    movingInRequestTracking: {
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null
    },
    meterSuggestions: {
        data: null,
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null
    },
    meterExistsBySerialNumber: {
        exists: null,
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null
    },
    meterExistsByRegistrationNumber: {
        exists: null,
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null
    },
    estimatedMonthlyPaiement: {
        value: null,
        errorMessage: null,
        loading: false,
        responseCode: null,
        success: false
    },
    waterCharge: {
        data: null,
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null
    },
    deliveryPointAddressSearch: {
        errorMessage: null,
        responseCode: null,
        loading: false,
        success: false
    },
    subscribe: {
        errorMessage: null,
        responseCode: null,
        loading: false,
        success: false
    },
    paymentInformations: {
        paymentType: null,
        withdrawalDay: null
    },
    dqeSuggestionMeterAddress: null,
    dqeSuggestionBillingAddress: null,
    countryAutoComplete: {
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null,
        countrySuggestions: [],
        selectedCountry: null
    },
    cityAutoComplete: {
        loading: false,
        success: false,
        errorMessage: null,
        responseCode: null,
        citySuggestions: [],
        selectedCity: null
    },
};
var moveInState = /** @class */ (function (_super) {
    __extends(moveInState, _super);
    function moveInState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    moveInState.prototype.setDqeSuggestionMeterAddress = function (address) {
        this.draftState.dqeSuggestionMeterAddress = address;
    };
    moveInState.prototype.setDqeSuggestionBillingAddress = function (address) {
        this.draftState.dqeSuggestionBillingAddress = address;
    };
    // -----------------Subscription API CALL---------------------//
    // -------------------------BEGIN-----------------------------//
    moveInState.prototype.subscribe = function () {
        this.draftState.subscribe.loading = true;
        this.draftState.subscribe.responseCode = null;
        this.draftState.subscribe.success = false;
        this.draftState.subscribe.errorMessage = null;
    };
    moveInState.prototype.resetSubscribe = function () {
        this.draftState.subscribe.loading = false;
        this.draftState.subscribe.responseCode = null;
        this.draftState.subscribe.success = false;
        this.draftState.subscribe.errorMessage = null;
    };
    moveInState.prototype.subscribeSuccess = function () {
        this.draftState.subscribe.loading = false;
        this.draftState.subscribe.responseCode = 204;
        this.draftState.subscribe.success = true;
        this.draftState.subscribe.errorMessage = null;
    };
    moveInState.prototype.subscribeFailure = function (errorMessage, errorCode) {
        this.draftState.subscribe.loading = false;
        this.draftState.subscribe.success = false;
        this.draftState.subscribe.responseCode = errorCode;
        this.draftState.subscribe.errorMessage = errorMessage;
    };
    // --------------------------END------------------------------//
    // ------------Commune auto complet API CALL------------------//
    // -------------------------BEGIN-----------------------------//
    moveInState.prototype.getCommuneSuggestion = function (commune) {
        this.draftState.communeAutoComplete.loading = true;
        this.draftState.communeAutoComplete.responseCode = null;
        this.draftState.communeAutoComplete.success = false;
        this.draftState.communeAutoComplete.errorMessage = null;
        if (!commune.length) {
            this.draftState.communeAutoComplete.communeSuggestions = [];
        }
    };
    moveInState.prototype.getCommuneSuggestionSuccess = function (suggestions) {
        this.draftState.communeAutoComplete.loading = false;
        this.draftState.communeAutoComplete.responseCode = 200;
        this.draftState.communeAutoComplete.success = true;
        this.draftState.communeAutoComplete.errorMessage = null;
        this.draftState.communeAutoComplete.communeSuggestions = suggestions;
    };
    moveInState.prototype.getCommuneSuggestionFailure = function (errorMessage, errorCode) {
        this.draftState.communeAutoComplete.loading = false;
        this.draftState.communeAutoComplete.success = false;
        this.draftState.communeAutoComplete.responseCode = errorCode;
        this.draftState.communeAutoComplete.errorMessage = errorMessage;
        this.draftState.communeAutoComplete.communeSuggestions = [];
    };
    // --------------------------END------------------------------//
    // ------------City auto complet API CALL------------------//
    // -------------------------BEGIN-----------------------------//
    moveInState.prototype.getCountrySuggestion = function () {
        this.draftState.countryAutoComplete.loading = true;
        this.draftState.countryAutoComplete.responseCode = null;
        this.draftState.countryAutoComplete.success = false;
        this.draftState.countryAutoComplete.errorMessage = null;
        this.draftState.countryAutoComplete.countrySuggestions = [];
    };
    moveInState.prototype.getCountrySuggestionSuccess = function (suggestions) {
        this.draftState.countryAutoComplete.loading = false;
        this.draftState.countryAutoComplete.responseCode = 200;
        this.draftState.countryAutoComplete.success = true;
        this.draftState.countryAutoComplete.errorMessage = null;
        this.draftState.countryAutoComplete.countrySuggestions = suggestions;
    };
    moveInState.prototype.getCountrySuggestionFailure = function (errorMessage, errorCode) {
        this.draftState.countryAutoComplete.loading = false;
        this.draftState.countryAutoComplete.success = false;
        this.draftState.countryAutoComplete.responseCode = errorCode;
        this.draftState.countryAutoComplete.errorMessage = errorMessage;
        this.draftState.countryAutoComplete.countrySuggestions = [];
    };
    // --------------------------END------------------------------//
    // ------------City auto complet API CALL------------------//
    // -------------------------BEGIN-----------------------------//
    moveInState.prototype.getCitySuggestion = function (payload) {
        var _a;
        this.draftState.cityAutoComplete.loading = true;
        this.draftState.cityAutoComplete.responseCode = null;
        this.draftState.cityAutoComplete.success = false;
        this.draftState.cityAutoComplete.errorMessage = null;
        if (!((_a = payload === null || payload === void 0 ? void 0 : payload.city) === null || _a === void 0 ? void 0 : _a.length)) {
            this.draftState.cityAutoComplete.citySuggestions = [];
        }
    };
    moveInState.prototype.getCitySuggestionSuccess = function (suggestions) {
        this.draftState.cityAutoComplete.loading = false;
        this.draftState.cityAutoComplete.responseCode = 200;
        this.draftState.cityAutoComplete.success = true;
        this.draftState.cityAutoComplete.errorMessage = null;
        this.draftState.cityAutoComplete.citySuggestions = suggestions;
    };
    moveInState.prototype.getCitySuggestionFailure = function (errorMessage, errorCode) {
        this.draftState.cityAutoComplete.loading = false;
        this.draftState.cityAutoComplete.success = false;
        this.draftState.cityAutoComplete.responseCode = errorCode;
        this.draftState.cityAutoComplete.errorMessage = errorMessage;
        this.draftState.cityAutoComplete.citySuggestions = [];
    };
    // --------------------------END------------------------------//
    // ------------Estimated payment based on consumption API Call------------------//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.getCommuneEligibility = function (CommuneSuggestion) {
        this.draftState.communeEligibility.loading = true;
        this.draftState.communeEligibility.responseCode = null;
        this.draftState.communeEligibility.success = false;
        this.draftState.communeEligibility.errorMessage = null;
        this.draftState.communeEligibility.eligibility = null;
        this.draftState.formData.inseeCode = CommuneSuggestion.value.inseeCode;
        this.draftState.communeAutoComplete.selectedValue = CommuneSuggestion;
        this.draftState.communeEligibility.disabled = null;
    };
    moveInState.prototype.getCommuneEligibilitySuccess = function (payload) {
        this.draftState.communeEligibility.loading = false;
        this.draftState.communeEligibility.responseCode = payload.responseCode;
        this.draftState.communeEligibility.success = true;
        this.draftState.communeEligibility.errorMessage = null;
        this.draftState.communeEligibility.eligibility = payload.eligibility;
        this.draftState.communeEligibility.disabled = null;
        this.draftState.communeEligibility.crmEnabled = payload.crmEnabled;
    };
    moveInState.prototype.getCommuneEligibilityFailure = function (errorMessage, errorCode, disabled) {
        this.draftState.communeEligibility.loading = false;
        this.draftState.communeEligibility.success = false;
        this.draftState.communeEligibility.responseCode = errorCode;
        this.draftState.communeEligibility.errorMessage = errorMessage;
        this.draftState.communeEligibility.eligibility = null;
        this.draftState.communeEligibility.disabled = disabled;
        this.draftState.communeEligibility.crmEnabled = null;
    };
    // -------------------------------END-------------------------------------------//
    // ------------Estimated payment based on consumption API Call------------------//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.getEstimatedMonthlyPaiement = function (payload) {
        this.draftState.estimatedMonthlyPaiement.loading = true;
        this.draftState.estimatedMonthlyPaiement.responseCode = null;
        this.draftState.estimatedMonthlyPaiement.success = false;
        this.draftState.estimatedMonthlyPaiement.errorMessage = null;
        this.draftState.estimatedMonthlyPaiement.value = null;
        this.draftState.formData.estimatedConsumption = payload;
    };
    moveInState.prototype.getEstimatedMonthlyPaiementSuccess = function (value) {
        this.draftState.estimatedMonthlyPaiement.loading = false;
        this.draftState.estimatedMonthlyPaiement.responseCode = 200;
        this.draftState.estimatedMonthlyPaiement.success = true;
        this.draftState.estimatedMonthlyPaiement.errorMessage = null;
        this.draftState.estimatedMonthlyPaiement.value = value;
    };
    moveInState.prototype.getEstimatedMonthlyPaiementFailure = function (errorMessage, errorCode) {
        this.draftState.estimatedMonthlyPaiement.loading = false;
        this.draftState.estimatedMonthlyPaiement.success = false;
        this.draftState.estimatedMonthlyPaiement.responseCode = errorCode;
        this.draftState.estimatedMonthlyPaiement.errorMessage = errorMessage;
        this.draftState.estimatedMonthlyPaiement.value = null;
    };
    // -----------------------------------END---------------------------------------//
    // ------------Water Charge by Commune(InseeCode) based on Admin=>EDMC API Call------------------//
    // ----------------------------------BEGIN-------------------------------------------------------//
    moveInState.prototype.fetchWaterChargeByCommune = function (inseeCode) {
        this.draftState.waterCharge.loading = true;
        this.draftState.waterCharge.errorMessage = null;
        this.draftState.waterCharge.responseCode = null;
        this.draftState.waterCharge.success = false;
        this.draftState.waterCharge.data = null;
    };
    moveInState.prototype.fetchWaterChargeByCommuneSuccess = function (waterCharge) {
        this.draftState.waterCharge.loading = false;
        this.draftState.waterCharge.data = waterCharge;
        this.draftState.waterCharge.responseCode = 200;
        this.draftState.waterCharge.success = true;
        this.draftState.waterCharge.errorMessage = null;
    };
    moveInState.prototype.fetchWaterChargeByCommuneFailure = function (errorMsg, responseCode) {
        this.draftState.waterCharge.loading = false;
        this.draftState.waterCharge.errorMessage = errorMsg;
        this.draftState.waterCharge.data = null;
        this.draftState.waterCharge.responseCode = responseCode;
        this.draftState.waterCharge.success = false;
    };
    // ----------------------------------END---------------------------------------------------------//
    // ------deliverypoint address search based on meter serial number API Call-----//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.getDeliveryPointAddress = function (meterSerialNumber) {
        this.draftState.deliveryPointAddressSearch.loading = true;
        this.draftState.deliveryPointAddressSearch.responseCode = null;
        this.draftState.deliveryPointAddressSearch.success = false;
        this.draftState.deliveryPointAddressSearch.errorMessage = null;
    };
    moveInState.prototype.getDeliveryPointAddressSuccess = function (geographicAddress) {
        this.draftState.deliveryPointAddressSearch.loading = false;
        this.draftState.deliveryPointAddressSearch.responseCode = 200;
        this.draftState.deliveryPointAddressSearch.success = true;
        this.draftState.deliveryPointAddressSearch.errorMessage = null;
        this.draftState.formData.deliveryPoint = { geographicAddress: geographicAddress };
        this.draftState.dqeSuggestionMeterAddress = null;
    };
    moveInState.prototype.getDeliveryPointAddressFailure = function (errorMessage, errorCode) {
        this.draftState.deliveryPointAddressSearch.loading = false;
        this.draftState.deliveryPointAddressSearch.success = false;
        this.draftState.deliveryPointAddressSearch.responseCode = errorCode;
        this.draftState.deliveryPointAddressSearch.errorMessage = errorMessage;
        this.draftState.formData.deliveryPoint = null;
    };
    // -----------------------------------END---------------------------------------//
    // ----------------------------------Meters by Address-------------------------------------------//
    // ----------------------------------------BEGIN-------------------------------------------------//
    moveInState.prototype.fetchMetersByAddress = function (zipCode, streetAddress, residenceNumber) {
        this.draftState.meterSuggestions.loading = true;
        this.draftState.meterSuggestions.errorMessage = null;
        this.draftState.meterSuggestions.responseCode = null;
        this.draftState.meterSuggestions.success = false;
        this.draftState.meterSuggestions.data = null;
    };
    moveInState.prototype.fetchMetersByAddressSuccess = function (metersList) {
        this.draftState.meterSuggestions.loading = false;
        this.draftState.meterSuggestions.data = metersList;
        this.draftState.meterSuggestions.responseCode = 200;
        this.draftState.meterSuggestions.success = true;
        this.draftState.meterSuggestions.errorMessage = null;
    };
    moveInState.prototype.fetchMetersByAddressFailure = function (errorMsg, responseCode) {
        this.draftState.meterSuggestions.loading = false;
        this.draftState.meterSuggestions.errorMessage = errorMsg;
        this.draftState.meterSuggestions.data = null;
        this.draftState.meterSuggestions.responseCode = responseCode;
        this.draftState.meterSuggestions.success = false;
    };
    // ------------------------------------------END-------------------------------------------------//
    // ------------ Check if the meter serial number actually exists API Call------------------//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.anyMeterBySerialNumber = function (meterSerialNumber, inseeCode) {
        this.draftState.meterExistsBySerialNumber.loading = true;
        this.draftState.meterExistsBySerialNumber.errorMessage = null;
        this.draftState.meterExistsBySerialNumber.responseCode = null;
        this.draftState.meterExistsBySerialNumber.success = false;
        this.draftState.meterExistsBySerialNumber.exists = null;
    };
    moveInState.prototype.anyMeterBySerialNumberSuccess = function () {
        this.draftState.meterExistsBySerialNumber.loading = false;
        this.draftState.meterExistsBySerialNumber.exists = true;
        this.draftState.meterExistsBySerialNumber.responseCode = 204;
        this.draftState.meterExistsBySerialNumber.success = true;
        this.draftState.meterExistsBySerialNumber.errorMessage = null;
    };
    moveInState.prototype.anyMeterBySerialNumberFailure = function (errorMsg, responseCode) {
        this.draftState.meterExistsBySerialNumber.loading = false;
        this.draftState.meterExistsBySerialNumber.errorMessage = errorMsg;
        this.draftState.meterExistsBySerialNumber.exists = null;
        this.draftState.meterExistsBySerialNumber.responseCode = responseCode;
        this.draftState.meterExistsBySerialNumber.success = false;
    };
    // -------------------------------END-------------------------------------------//
    // ------------ Check if the meter registration number actually exists API Call------------------//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.anyMeterByRegistrationNumber = function (meterRegistrationNumber) {
        this.draftState.meterExistsByRegistrationNumber.loading = true;
        this.draftState.meterExistsByRegistrationNumber.errorMessage = null;
        this.draftState.meterExistsByRegistrationNumber.responseCode = null;
        this.draftState.meterExistsByRegistrationNumber.success = false;
        this.draftState.meterExistsByRegistrationNumber.exists = null;
    };
    moveInState.prototype.anyMeterByRegistrationNumberSuccess = function () {
        this.draftState.meterExistsByRegistrationNumber.loading = false;
        this.draftState.meterExistsByRegistrationNumber.exists = true;
        this.draftState.meterExistsByRegistrationNumber.responseCode = 204;
        this.draftState.meterExistsByRegistrationNumber.success = true;
        this.draftState.meterExistsByRegistrationNumber.errorMessage = null;
    };
    moveInState.prototype.anyMeterByRegistrationNumberFailure = function (errorMsg, responseCode) {
        this.draftState.meterExistsByRegistrationNumber.loading = false;
        this.draftState.meterExistsByRegistrationNumber.errorMessage = errorMsg;
        this.draftState.meterExistsByRegistrationNumber.exists = null;
        this.draftState.meterExistsByRegistrationNumber.responseCode = responseCode;
        this.draftState.meterExistsByRegistrationNumber.success = false;
    };
    // -------------------------------END-------------------------------------------//
    // -------------------- Creates the MovingIn Request ---------------------------//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.CreateMovingInRequest = function (movingInRequest) {
        this.draftState.movingInRequestCreation.loading = true;
        this.draftState.movingInRequestCreation.errorMessage = null;
        this.draftState.movingInRequestCreation.responseCode = null;
        this.draftState.movingInRequestCreation.success = false;
        this.draftState.movingInRequestCreation.data = null;
    };
    moveInState.prototype.CreateMovingInRequestSuccess = function (movingInRequestId) {
        this.draftState.movingInRequestCreation.loading = false;
        this.draftState.movingInRequestCreation.data = movingInRequestId;
        this.draftState.formData.movingInRequestId = movingInRequestId;
        this.draftState.movingInRequestCreation.responseCode = 200;
        this.draftState.movingInRequestCreation.success = true;
        this.draftState.movingInRequestCreation.errorMessage = null;
    };
    moveInState.prototype.CreateMovingInRequestFailure = function (errorMsg, responseCode) {
        this.draftState.movingInRequestCreation.loading = false;
        this.draftState.movingInRequestCreation.errorMessage = errorMsg;
        this.draftState.movingInRequestCreation.data = null;
        this.draftState.movingInRequestCreation.responseCode = responseCode;
        this.draftState.movingInRequestCreation.success = false;
    };
    // -------------------------------END-------------------------------------------//
    // -------------------- Tracks the MovingIn Request ---------------------------//
    // ----------------------------------BEGIN--------------------------------------//
    moveInState.prototype.TrackMovingInRequest = function (movingInRequestPayload) {
        this.draftState.movingInRequestTracking.loading = true;
        this.draftState.movingInRequestTracking.errorMessage = null;
        this.draftState.movingInRequestTracking.responseCode = null;
        this.draftState.movingInRequestTracking.success = false;
    };
    moveInState.prototype.TrackMovingInRequestSuccess = function () {
        this.draftState.movingInRequestTracking.loading = false;
        this.draftState.movingInRequestTracking.responseCode = 204;
        this.draftState.movingInRequestTracking.success = true;
        this.draftState.movingInRequestTracking.errorMessage = null;
    };
    moveInState.prototype.TrackMovingInRequestFailure = function (errorMsg, responseCode) {
        this.draftState.movingInRequestTracking.loading = false;
        this.draftState.movingInRequestTracking.errorMessage = errorMsg;
        this.draftState.movingInRequestTracking.responseCode = responseCode;
        this.draftState.movingInRequestTracking.success = false;
    };
    // -------------------------------END-------------------------------------------//
    // -------------------- set form data ----------------------//
    moveInState.prototype.setInseeCode = function (inseeCode) {
        this.draftState.formData.inseeCode = inseeCode;
    };
    moveInState.prototype.setAccountHolder = function (client) {
        this.draftState.formData.accountHolder = __assign(__assign({}, this.draftState.formData.accountHolder), client);
    };
    moveInState.prototype.setJointAccountHolder = function (jointAccountHolder) {
        this.draftState.formData.jointAccountHolder = jointAccountHolder;
    };
    moveInState.prototype.setMeterData = function (meterData) {
        this.draftState.formData.meter = meterData;
    };
    moveInState.prototype.setDeliveryPointAddress = function (geographicAddress) {
        this.draftState.formData.deliveryPoint = { geographicAddress: geographicAddress };
    };
    moveInState.prototype.setResidenceData = function (residence) {
        this.draftState.formData.residence = residence;
    };
    moveInState.prototype.setBillingAddress = function (address) {
        this.draftState.formData.billingAddress = address;
    };
    moveInState.prototype.setpaymentInformations = function (paymentInformations) {
        this.draftState.paymentInformations = paymentInformations;
    };
    moveInState.prototype.setBillinginformation = function (billingInformation) {
        this.draftState.formData.billingInformation = billingInformation;
    };
    moveInState.prototype.setConsumptionEstimate = function (estimatedConsumption) {
        this.draftState.formData.estimatedConsumption = estimatedConsumption;
    };
    moveInState.prototype.setAccountHolderType = function (type) {
        var _a;
        this.draftState.formData.accountHolder = __assign(__assign({}, (_a = this.draftState.formData) === null || _a === void 0 ? void 0 : _a.accountHolder), { type: type });
    };
    moveInState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    return moveInState;
}(immer_reducer_1.ImmerReducer));
exports.moveInState = moveInState;
exports.moveInActions = (0, immer_reducer_1.createActionCreators)(moveInState);
exports.moveInReducerFunction = (0, immer_reducer_1.createReducerFunction)(moveInState, exports.initialState);
